import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "m-0" }
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "breadcrumb float-sm-right" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Dashboard")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item active" }, "Dashboard", -1)
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "container-fluid" }
const _hoisted_13 = {
  class: "row",
  style: {"display":"flex"}
}
const _hoisted_14 = { class: "col-lg-4 col-6" }
const _hoisted_15 = { class: "small-box bg-info" }
const _hoisted_16 = { class: "inner" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "Jumlah Program Donasi", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ion ion-bag" })
], -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("More info ")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)
const _hoisted_21 = { class: "col-lg-4 col-6" }
const _hoisted_22 = { class: "small-box bg-success" }
const _hoisted_23 = { class: "inner" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, "Donasi Berlangsung", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ion ion-stats-bars" })
], -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode("More info ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)
const _hoisted_28 = { class: "col-lg-4 col-6" }
const _hoisted_29 = { class: "small-box bg-warning" }
const _hoisted_30 = { class: "inner" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, "Donatur", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ion ion-person-add" })
], -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode("More info ")
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)
const _hoisted_35 = { class: "col-lg-8" }
const _hoisted_36 = { class: "card" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h4", { class: "header-title mb-3" }, null, -1)
const _hoisted_38 = { id: "chart_trx" }
const _hoisted_39 = { ref: "chartCanvas" }
const _hoisted_40 = { class: "col-lg-4" }
const _hoisted_41 = { class: "card" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h4", { class: "header-title mb-3" }, null, -1)
const _hoisted_43 = { id: "tabel_trx" }
const _hoisted_44 = { ref: "chartCanvas" }
const _hoisted_45 = { class: "col-lg-4" }
const _hoisted_46 = { class: "card" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h4", { class: "header-title mb-3" }, null, -1)
const _hoisted_48 = { id: "chart_pie" }
const _hoisted_49 = { class: "col-lg-8" }
const _hoisted_50 = { class: "card" }
const _hoisted_51 = { class: "card-body" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h4", { class: "header-title mb-3" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  value: "{{this.records.length}}"
}, null, -1)
const _hoisted_54 = { class: "table-responsive" }
const _hoisted_55 = {
  class: "table table-bordered table-striped table-hover",
  ref: "dataTable"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "List Program Donasi"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Donasi")
  ])
], -1)
const _hoisted_57 = ["innerHTML"]

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_ChartComponent = _resolveComponent("ChartComponent")
  const _component_PieComponent = _resolveComponent("PieComponent")
  const _component_ProgramBulan = _resolveComponent("ProgramBulan")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("labels.dashboard")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("ol", _hoisted_7, [
              _createElementVNode("li", _hoisted_8, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _hoisted_10
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("h3", null, _toDisplayString(this.tP), 1),
                _hoisted_17
              ]),
              _hoisted_18,
              _createVNode(_component_router_link, {
                to: "/",
                class: "small-box-footer"
              }, {
                default: _withCtx(() => [
                  _hoisted_19,
                  _hoisted_20
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("h3", null, _toDisplayString(this.tD), 1),
                _hoisted_24
              ]),
              _hoisted_25,
              _createVNode(_component_router_link, {
                to: "/",
                class: "small-box-footer"
              }, {
                default: _withCtx(() => [
                  _hoisted_26,
                  _hoisted_27
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("h3", null, _toDisplayString(this.donatur), 1),
                _hoisted_31
              ]),
              _hoisted_32,
              _createVNode(_component_router_link, {
                to: "/",
                class: "small-box-footer"
              }, {
                default: _withCtx(() => [
                  _hoisted_33,
                  _hoisted_34
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_ChartComponent),
                _createElementVNode("canvas", _hoisted_39, null, 512)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_PieComponent),
                _createElementVNode("canvas", _hoisted_44, null, 512)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                _createVNode(_component_ProgramBulan)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _hoisted_53,
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("table", _hoisted_55, [
                    _hoisted_56,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (el, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", {
                            innerHTML: el.program
                          }, null, 8, _hoisted_57),
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatCurrency(el.total)), 1)
                        ]))
                      }), 128))
                    ])
                  ], 512)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}